import React, {Component} from "react";
import "./EditVirtualChildren.scss";
import EditVirtualChildrenModal from "./EditVirtualChildrenModal";

class EditVirtualChildrenButton extends Component {
    constructor(props) {
        super(props);

        const searchParams = new URLSearchParams(window.location.search);
        const showModal = searchParams.get('editVirtualChildren') === 'true';

        this.state = {
            showModal
        };
    }

    componentDidMount() {
        if (this.state.showModal) {
            // Optional: remove the param after opening
            const url = new URL(window.location.href);
            url.searchParams.delete('editVirtualChildren');
            window.history.replaceState({}, '', url.pathname + url.search);
        }
    }

    render() {
        return [
            <div key="trigger" onClick={() => this.setState({showModal: true})}>
                {this.props.children}
            </div>,
            <EditVirtualChildrenModal
                key="modal"
                onClose={() => this.setState({showModal: false})}
                open={this.state.showModal}
                item={this.props.item}
            />
        ];
    }
}

export default EditVirtualChildrenButton;
